import { EUnreadType } from '.';
import { EUserStatus } from '..';
//@ts-ignore
import _ from 'lodash'
import { UserLeaveGroupChat } from '../Chat';
import { handleTruncateContent } from '@/helpers/Common';
/**
 * @param id: number
 * @param is_readed: boolean
 * @param unread_icon: string[]
 * @param unread_target_id: number
 * @param unread_type: number
 * @param update_by_user: string[]
 * @param update_date: string
 */
export interface IUnreadNotification {
  id: number
  allow_anonymous_comment: boolean
  common_topic_name: string
  emergency_contact: boolean
  group_id: number
  group_name: string
  title: string
  name: string //for chat
  only_user_chat: boolean //for chat
  topic_comment_id: number //for topic
  content: string
  content_text: string
  comment_content_text: string
  type: number
  unread_icon: string[]
  unread_target_id: number
  unread_type: EUnreadType
  update_by_user: string
  updated_at: string
  selected: boolean
  user_active_status: EUserStatus
  user_leave_chat: UserLeaveGroupChat
  message_id?: number

  // translate
  isTranslated: boolean
  translatedText: string
  translatedTitle: string

  hide_administrator?: boolean
}

export class UnreadNoti {
  id!: number
  allow_anonymous_comment: boolean = true
  common_topic_name: string = ''
  emergency_contact: boolean = false
  group_id!: number
  group_name: string = ''
  title: string = ''
  name: string = '' //for chat
  only_user_chat: boolean = false //for chat
  content: string = ''
  type!: number
  unread_icon: string[] = []
  unread_target_id!: number
  unread_type!: EUnreadType
  update_by_user: string = ''
  updated_at: string = ''
  selected: boolean = false
  user_active_status!: EUserStatus

  // translate
  isTranslated: boolean = false
  translatedText: string = ''
  translatedTitle: string = ''

  constructor(init?: Partial<UnreadNoti>, className?: string) {
    Object.assign(this, init)
    if (this.content) {
      this.content = handleTruncateContent(this.content)
    }

    if (
      (!this.content ||
        this.content === 'ATTACH_FILE' ||
        this.content === 'MESSAGE_DELETED') &&
      this.unread_type === EUnreadType.CHAT_CONTENT
    ) {
      this.isTranslated = true
    }
  }
}

export interface IBellNotification {
  id: number
  user_avatar: string
  message: string
  is_unread: boolean
  time_check: string
}

export interface ILikeNotification {
  id: number
  like_by_user: string[]
  like_count: number
  like_icon: string
  like_type: number
  like_target: string
  like_target_id: number
  group_id: number
}

/**
 * @param notifications: number[]
 */
export interface NotificationSelected {
  notifications: number[]
}